import React, { useEffect, useRef, useState } from 'react';
import { activateAsync, changePlanToAsync, ChangeUpdateExistingPlanAsync, getLicenseActivationAndPageLoadDataAsync, RenewAsync } from './LicenseActivationSlice';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { useTranslation } from 'react-i18next';
import { getValueFromResource } from '../../../common/timeLiveFunction';
import package01 from "../../../assets/image/01.svg";
import package02 from "../../../assets/image/02.svg";
import package03 from "../../../assets/image/03.svg";
import package04 from "../../../assets/image/05.svg";
import package05 from "../../../assets/image/04.svg";
import './Packages.css';
import { licenseActivationInitialsForAdd, licenseActivationInitialsForUpdate } from './interfaces/LicenseActivationClass';
import { ShowSwal } from '../../../common/SweetAlert';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { GetPlanJson } from './GetPlanJson';

const Packages = () => {
    const { PackagesData, SelectedCurrentHostedPackage, applicationMode, selectedRecord, isValidLicenseActivation, isFreeLiteVersion, isReload, isHostedPaidCustomerLicenseExpired, expiryDateLicense, isFreeAccount, rowscount, numberOfUsersAllowed, IsHostedPaidCustomer, IsUpgradeExistingPlan, DISABLE_LICENSE } = useAppSelector((state) => state.licenseActivation);
    // const [applicationMode, setapplicationMode] = useState<any>('Hosted');
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(licenseActivationInitialsForAdd);
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [selectedPackageValue, setSelectedPackageValue] = useState<string | null>(null);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [packageOptions, setPackageOptions] = useState<any[]>([]);
    // const [getLabelEnterprice, setGetLabelEnterprice] = useState('');
    // const [getvalue, setGetValue] = useState('');
    const licenseExpireFlag = localStorage.getItem("IsLicenseExpired");
    const IsFreeLicenseExpired = localStorage.getItem("IsFreeLicenseExpired");
    let expireFlag = (licenseExpireFlag === "true" || IsFreeLicenseExpired === "true");

    useEffect(() => {

        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;

            Object.keys(licenseActivationInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })

            stateItem.MachineId = stateItem.MachineId;
            if (applicationMode === "Hosted") {
                stateItem.PackageCode = SelectedCurrentHostedPackage;
                let transformedOptions = PackagesData.map((item: any) => ({
                    value: item.PackageCode,
                    label: item.PackageName
                }));
                setPackageOptions(transformedOptions);
            }

            stateItem.ActivationType = (stateItem.ActivationType === null || stateItem.ActivationType === undefined || stateItem.ActivationType === '') ? "Online Activation" : stateItem.ActivationType;
            setCurrentFieldsData(stateItem);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
    }, [selectedRecord])

    useEffect(() => {
        dispatch(getLicenseActivationAndPageLoadDataAsync());
    }, [dispatch]);

    useEffect(() => {
        if (applicationMode === 'Hosted' && PackagesData.length > 0) {
            const transformedOptions = PackagesData.map((item: any) => ({
                value: item.PackageCode,
                label: item.PackageName,
                id: item.SystemLicenseId
            }));

            setPackageOptions(transformedOptions);
            setSelectedPackageValue(SelectedCurrentHostedPackage || null);
        }
    }, [PackagesData, SelectedCurrentHostedPackage]);

    useEffect(() => {
        if (isReload) {
            dispatch(getLicenseActivationAndPageLoadDataAsync());
        }
    }, [isReload])

    const handleTextChange = (e: any) => {
        if (e.target.id === 'OnlineActivation') {
            setCurrentFieldsData({ ...currentFieldsData, 'ActivationType': 'Online Activation' })
        }
        else if (e.target.id === 'ManualActivation') {
            setCurrentFieldsData({ ...currentFieldsData, 'ActivationType': 'Manual Activation' })
        }
        else {
            setCurrentFieldsData({ ...currentFieldsData, [e.target.id]: (e.target.type === 'checkbox' ? e.target.checked : e.target.value.replace(/^ +/, '')) })
        }
    }

    const handlePackageSelection = (item: any) => {
        setSelectedPackageValue(item.value);
    };

    const handleContinueClick = () => {
        if (selectedPackageValue) {
            handlePackageClick(selectedPackageValue);
        }
    };

    const onUpdatePlanClick = () => {
        // const { value, label } = selectedOption;
        dispatch(changePlanToAsync(selectedPackageValue))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.ChangePlanToPaymentURL !== null && originalPromiseResult.ChangePlanToPaymentURL !== undefined && originalPromiseResult.ChangePlanToPaymentURL !== "") {
                    window.location.href = originalPromiseResult.ChangePlanToPaymentURL;
                }

            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onUpdateExsistingPlanClick = () => {
        dispatch(ChangeUpdateExistingPlanAsync(selectedPackageValue))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.PaymentURL !== null && originalPromiseResult.PaymentURL !== undefined && originalPromiseResult.PaymentURL !== "") {
                    window.location.href = originalPromiseResult.PaymentURL;
                }
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const onRenewClick = () => {
        dispatch(RenewAsync())
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.RenewURL !== null && originalPromiseResult.RenewURL !== undefined && originalPromiseResult.RenewURL !== "") {
                    window.location.href = originalPromiseResult.RenewURL;
                }
            })
            .catch((rejectedValueOrSerializedError) => {

            })
    }

    const handlePackageClick = (value: string) => {
        dispatch(changePlanToAsync(value))
            .unwrap()
            .then((result) => {
                if (result.ChangePlanToPaymentURL) {
                    window.location.href = result.ChangePlanToPaymentURL;
                }
            })
            .catch(() => { });
    };

    const renderLicenseInfo = (pkg: any) => {
        const isCurrentPackage = pkg.value === SelectedCurrentHostedPackage;

        if (!isFreeLiteVersion && isCurrentPackage) {
            return (
                <div className='row'>
                    <div className='col-12 mb-3 d-flex gap-4'>
                        <div>
                            <h4 style={{ fontSize: '14px' }}>
                                {getValueFromResource('License Users Usage', dispatch, t)}
                            </h4>
                            <span className='text-gray-500'>
                                {rowscount + getValueFromResource(" Out Of ", dispatch, t) + numberOfUsersAllowed + " " + getValueFromResource('Users', dispatch, t)}
                            </span>
                        </div>
                        <div>
                            <h4 style={{ fontSize: '14px' }}>
                                {getValueFromResource('Expires On', dispatch, t)}
                            </h4>
                            <span className={`text-gray-500 ${expireFlag ? 'text-danger fw-bold' : ''}`}>
                                {expiryDateLicense}
                            </span>
                        </div>
                    </div>
                </div>
            );
        }

        if (isFreeLiteVersion && isCurrentPackage) {
            return (
                <div className='row'>
                    <div className='col-md-9 mb-3'>
                        <span className='text-gray-500'>
                            {getValueFromResource('This is the 30 days free trial with unlimited users / all features. After 30 days, your plan will be automatically converted to Free Lite edition, valid only for 3 users and 3 projects.', dispatch, t)}
                        </span>
                    </div>
                </div>
            );
        }

        return null;
    };


    const renderExpiryWarnings = (pkg: any) => {
        const isCurrentPackage = pkg.value === SelectedCurrentHostedPackage;
        let descVal = GetPlanJson.find((item) => item.systemLicenseId.toLowerCase() === pkg.id);

        if (!isCurrentPackage) {
            return (
                <div className='row'>
                    <div className='col-md-9 mb-3'>
                        <div style={{ fontSize: '14px' }}>
                            <span className='text-gray-500'>
                                {getValueFromResource(descVal?.description ?? '', dispatch, t)}
                            </span>
                        </div>
                    </div>
                </div>
            );
        }

        if (isHostedPaidCustomerLicenseExpired || expireFlag) {
            return (
                <div className='row'>
                    <div className='col-md-12 mb-3'>
                        <div style={{ fontSize: '14px' }}>
                            <span className='text-gray-500'>
                                {/* {getValueFromResource('Your subscription has been expired. In order to continue using TimeLive, make payment by clicking on "Renew Plan" button.', dispatch, t)} */}
                                {'Your subscription has been expired. To regain access, please choose a subscription plan.'}
                            </span>
                        </div>
                    </div>
                </div>
            );
        } else if (isFreeAccount && !isValidLicenseActivation) {
            return (
                <div className='row'>
                    <div className='col-md-9 mb-3'>
                        <div style={{ fontSize: '14px' }}>
                            {/* {getValueFromResource('Your 30 days trial has been expired. In order to continue using TimeLive, upgrade to the paid version', dispatch, t)} */}
                            {'Your trial has been expired. In order to continue using TimeLive, upgrade to the paid version'}
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();

        if (applicationMode === 'Installed') {
            if (currentFieldsData.ActivationType === 'Online Activation' && (!currentFieldsData.ActivationLicenseKey || currentFieldsData.ActivationLicenseKey === '')) {
                ShowSwal(t("Validation"), t('License Key'), 'error');
                return false;
            } else if (currentFieldsData.ActivationType === 'Manual Activation' && (!currentFieldsData.ActivationMachineKey || currentFieldsData.ActivationMachineKey === '')) {
                ShowSwal(t("Validation"), t('Machine Key'), 'error');
                return false;
            }

            dispatch(activateAsync(currentFieldsData))
                .unwrap()
                .then((originalPromiseResult) => {
                    if (originalPromiseResult.StatusCode === "200") {
                        Swal.fire({
                            title: "Success",
                            text: originalPromiseResult.ResponseMessage,
                            icon: 'success',
                            confirmButtonColor: '#0052cb',
                            confirmButtonText: 'Okay'
                        }).then((result: any) => {
                            if (result.isConfirmed) {
                                localStorage.setItem("IsLicenseExpired", "false");
                                navigate('/');
                            }
                        });
                    } else {
                        ShowSwal("Error", originalPromiseResult.ResponseMessage, 'error');
                    }
                })
                .catch((rejectedValueOrSerializedError) => {

                });
        }
    };

    return (

        <>
            {DISABLE_LICENSE !== 'Yes' && (
                <>
                    {applicationMode == "Installed" ? (
                        <div className="form-wrapper d-flex justify-content-center align-items-center">
                            <div className="form-card shadow-sm p-4">
                                <div className="packages-header p-3 border-bottom">
                                    <h3 className="card-title fw-bold headerTitle">{getValueFromResource('License Activation', dispatch, t)}</h3>
                                </div>

                                <div className="row justify-content-center my-4">
                                    <div className="col-md-8">
                                        <label className="form-label fs-7 text-muted">
                                            {getValueFromResource('License Key', dispatch, t)}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="ActivationLicenseKey"
                                            name="ActivationLicenseKey"
                                            value={currentFieldsData.ActivationLicenseKey}
                                            onChange={handleTextChange}
                                            ref={defaultFocusRef}
                                            readOnly={currentFieldsData.ActivationType !== "Online Activation"}
                                        />
                                    </div>
                                </div>

                                <div className="row justify-content-center mb-4">
                                    <div className="col-md-8">
                                        <label className="form-label fs-7 text-muted">
                                            {getValueFromResource('Machine Key', dispatch, t)}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="ActivationMachineKey"
                                            name="ActivationMachineKey"
                                            value={currentFieldsData.ActivationMachineKey}
                                            onChange={handleTextChange}
                                            readOnly={currentFieldsData.ActivationType !== "Manual Activation"}
                                        />
                                    </div>
                                </div>

                                <div className="row justify-content-center mb-4">
                                    <div className="col-md-8">
                                        <label className="form-label fs-7 text-muted">
                                            {getValueFromResource('Machine Name', dispatch, t)}
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="MachineId"
                                            name="MachineId"
                                            value={currentFieldsData.MachineId}
                                            onChange={handleTextChange}
                                            readOnly
                                        />
                                    </div>
                                </div>

                                <div className="row justify-content-center mb-3">
                                    <div className="col-md-8">
                                        <label className="form-label fs-7 text-muted d-block mb-2">
                                            {getValueFromResource('Activation Type', dispatch, t)}
                                        </label>
                                        <div className="d-flex gap-5">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    id="OnlineActivation"
                                                    name="ActivationType"
                                                    type="radio"
                                                    value="Online Activation"
                                                    checked={currentFieldsData.ActivationType === "Online Activation"}
                                                    onChange={handleTextChange}
                                                />
                                                <label className="form-check-label ms-2 mt-3" htmlFor="OnlineActivation">
                                                    {getValueFromResource('Online Activation', dispatch, t)}
                                                </label>
                                            </div>

                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    id="ManualActivation"
                                                    name="ActivationType"
                                                    type="radio"
                                                    value="Manual Activation"
                                                    checked={currentFieldsData.ActivationType === "Manual Activation"}
                                                    onChange={handleTextChange}
                                                />
                                                <label className="form-check-label ms-2 mt-3" htmlFor="ManualActivation">
                                                    {getValueFromResource('Manual Activation', dispatch, t)}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {!isFreeAccount && (
                                    <div className='row justify-content-center mb-4'>
                                        <div className='col-md-8 mb-2'>
                                            <h4 style={{ fontSize: '14px' }}>
                                                {getValueFromResource('License Users Usage', dispatch, t)}
                                            </h4>
                                            <span className='d-block'>{
                                                rowscount + (getValueFromResource(" Out Of ", dispatch, t)) + numberOfUsersAllowed + " " + getValueFromResource('Users', dispatch, t)
                                            }</span>
                                        </div>

                                    </div>
                                )}
                                {!isValidLicenseActivation && (
                                    <div className='row justify-content-center mb-4'>
                                        <div className='col-md-8 mb-2'>
                                            <h4 style={{ fontSize: '14px' }}>
                                                {getValueFromResource('Unlimited User Support Expiry', dispatch, t)}
                                            </h4>
                                            <span className='d-block mt-1'>{expiryDateLicense}</span>
                                        </div>

                                    </div>
                                )}
                                {isFreeAccount && !isValidLicenseActivation && (
                                    <div className='row justify-content-center mb-4'>
                                        <div className='col-md-8 mb-3'>
                                            <span className='d-block'>
                                                {/* {t('(Your 30 days trial has been expired. In order to continue using TimeLive, upgrade to the paid version)')} */}
                                                {getValueFromResource('Your 30 days trial has been expired. In order to continue using TimeLive, upgrade to the paid version', dispatch, t)}
                                            </span>
                                        </div>
                                    </div>
                                )}
                                <div className="row justify-content-center mb-4">

                                    <div className='col-md-6 mb-3'>
                                        <button type="button"
                                            className="btn btn-primary btn-bs-btn-font-weight me-2 btn-sm"
                                            onClick={(e) => handleSubmit(e)}
                                        >
                                            {getValueFromResource('Activate', dispatch, t)}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    ) : applicationMode == "Hosted" && (
                        <>
                            <div className="packages-wrapper d-flex justify-content-center align-items-center">
                                {packageOptions.length > 0 && (
                                    <div className="packages-card shadow-sm">
                                        <div className="packages-header p-3 border-bottom">
                                            <h3 className="card-title fw-bold headerTitle">{getValueFromResource('Choose Upgrade Plan', dispatch, t)}</h3>
                                        </div>
                                        <div className="p-4">
                                            {packageOptions.map((pkg, index) => {
                                                let packageLabel = pkg.label === 'Enterprise (Unlimited Users)' ? 'Enterprise' : pkg.label
                                                return (
                                                    <div
                                                        className="p-3 mb-4"
                                                        style={{
                                                            border: pkg.value === selectedPackageValue ? "2px solid #007bff" : '1px solid #dee2e6',
                                                            borderRadius: '5px',
                                                            overflow: 'hidden',
                                                            cursor: 'pointer',
                                                            backgroundColor: pkg.value === selectedPackageValue ? "#F3F7FE" : "",
                                                        }}
                                                        onClick={() => handlePackageSelection(pkg)}
                                                    >
                                                        <div className="d-flex justify-content-between align-items-center py-4">
                                                            <div className='d-flex gap-4'>
                                                                <img
                                                                    src={index === 0 ? package01 : index === 1 ? package02 : index === 2 ? package03 : index === 3 ? package04 : package05}
                                                                    alt="package image"
                                                                    width={40}
                                                                    height={40}
                                                                />
                                                                <div className="d-flex flex-column">
                                                                    <h3
                                                                        style={{
                                                                            fontSize: '18px',
                                                                            marginBottom: '0',
                                                                            lineHeight: '1.2'
                                                                        }}
                                                                        className={`d-flex gap-4 card-title fw-bold ${pkg.value === selectedPackageValue ? 'text-primary' : ''}`}>
                                                                        {getValueFromResource(packageLabel, dispatch, t)} {(pkg.value === SelectedCurrentHostedPackage && expireFlag) ? < span className='btn btn-light-danger' style={{ padding: '2px 6px', fontSize: '12px' }}>Expired</span> : (pkg.value === SelectedCurrentHostedPackage && !expireFlag) && < span className='btn btn-light-success' style={{ padding: '2px 6px', fontSize: '12px' }}>Active</span>}
                                                                    </h3>
                                                                    {/* <p
                                                                        style={{
                                                                            fontSize: '16px',
                                                                            marginTop: '0',
                                                                            lineHeight: '1.2'
                                                                        }}
                                                                        className="text-gray-500"> */}
                                                                    {/* {getValueFromResource('You cannot access this organization until you choose a plan', dispatch, t)} */}
                                                                    {/* </p> */}
                                                                    {renderLicenseInfo(pkg)}

                                                                    {renderExpiryWarnings(pkg)}
                                                                </div>
                                                            </div>
                                                            {pkg.label === 'Enterprise (Unlimited Users)' ? (
                                                                <>

                                                                    <div className="d-flex gap-4 align-items-center justify-content-center" style={{ minHeight: '100%' }}>
                                                                        {pkg.label === 'Enterprise (Unlimited Users)' && (
                                                                            <button
                                                                                className="btn btn-outline-primary"
                                                                                style={{
                                                                                    padding: '4px 12px',
                                                                                    fontSize: '14px',
                                                                                    border: '1px solid #0d6efd',
                                                                                    color: '#0d6efd',
                                                                                    backgroundColor: '#fff',
                                                                                    borderRadius: '6px',
                                                                                    lineHeight: '1.5',
                                                                                    whiteSpace: 'nowrap',
                                                                                    // marginTop: "50%"
                                                                                }}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    window.location.href = 'mailto:sales@livetecs.com';
                                                                                }}
                                                                            >
                                                                                Contact Sales
                                                                            </button>
                                                                        )}
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="selectedPackage"
                                                                            value={pkg.value}
                                                                            checked={pkg.value === selectedPackageValue}
                                                                            onChange={() => handlePackageSelection(pkg)}
                                                                            id={`package-${pkg.value}`}
                                                                            style={{
                                                                                width: '20px',
                                                                                height: '20px',
                                                                                margin: '0'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '100%' }}>
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="radio"
                                                                        name="selectedPackage"
                                                                        value={pkg.value}
                                                                        checked={pkg.value === selectedPackageValue}
                                                                        onChange={() => handlePackageSelection(pkg)}
                                                                        id={`package-${pkg.value}`}
                                                                        style={{
                                                                            width: '20px',
                                                                            height: '20px',
                                                                            margin: '0'
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                            <div className="d-flex justify-content-right">

                                                {packageOptions.length > 0 && (
                                                    <div className="d-flex justify-content-end w-100 mt-3 gap-2">
                                                        {/* <button
                                        className="btn btn-primary fw-bold"
                                        onClick={handleContinueClick}
                                        disabled={getLabelEnterprice === 'Enterprise (Unlimited Users)'}
                                    >
                                        Continue to billing
                                    </button> */}
                                                        {(expireFlag && IsHostedPaidCustomer) && (
                                                            <button
                                                                className="btn btn-primary fw-bold"
                                                                onClick={onRenewClick}
                                                            >
                                                                Renew
                                                            </button>
                                                        )}
                                                        {IsUpgradeExistingPlan && (
                                                            <button
                                                                className="btn btn-primary fw-bold"
                                                                onClick={onUpdateExsistingPlanClick}
                                                            >
                                                                Update Existing Plan
                                                            </button>
                                                        )}
                                                        <button
                                                            className="btn btn-primary fw-bold"
                                                            onClick={onUpdatePlanClick}
                                                        >
                                                            Upgrade
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default Packages;